import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import "unfetch/polyfill";
import "../styles/main.css";
import config from "../config/config";
import PluginContainer from "./components/PluginContainer";
var getQueryParams = function (search) {
    var result = {};
    var params = search.substr(1);
    var queryParamArray = params.split('&');
    queryParamArray.forEach(function (queryParam) {
        var item = queryParam.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
};
var App = function () {
    var _a = useState({}), pluginData = _a[0], setPluginData = _a[1];
    var _b = useState(""), orgnaizationId = _b[0], setOrganizationId = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    useEffect(function () {
        var queryParams = getQueryParams(window.location.search);
        var isPreview = queryParams.isPreview, pluginId = queryParams.pluginId, orgId = queryParams.orgId;
        setIsLoading(true);
        // `isPreview` comes from a query param so it will always be a string
        var url = isPreview === 'true'
            ? config.API_URL + "/v1/plugins/" + pluginId + "/preview"
            : config.API_URL + "/v1/plugins/" + pluginId;
        // preview endpoint requires authentication so we have to send credentials
        fetch(url, {
            credentials: isPreview ? 'include' : 'omit',
            headers: (orgId ? { 'Organization-Identification': orgId } : {})
        })
            .then(function (r) { return r.json(); })
            .then(function (data) {
            setPluginData(data);
            setIsLoading(false);
            setOrganizationId(orgId);
        });
    }, []);
    return (h(PluginContainer, { data: pluginData, isLoading: isLoading, orgId: orgnaizationId }));
};
export default App;
